export default "__VITE_ASSET__Cbw3g67R__"